import * as actionTypes from "./actionTypes";

export const updateTransactions = (body) => {
    return {
        type: actionTypes.UPDATE_TRANSACTIONS,
        body
    }
}

export const openSocketConnection = uuid => {
    return{
        type: actionTypes.OPEN_SOCKET_CONNECTION,
        uuid
    }
}

export const socketPaymentSubscriber = uuid => {
    return{
        type: actionTypes.SOCKET_PAYMENT_SUBSCRIBER,
        uuid
    }
}

export const setPaymentRequest = (paymentRequest) => {
    return{
        paymentRequest,
        type: actionTypes.SET_PAYMENT_REQUEST
    }
}